<template>
<div>
  <CContainer
    class="approval-overtime"
    v-if="requestInfo"
  >
    <div>
      <!-- <div>
        <h2>{{ $t("label.label_remote_infomation") }}</h2>
      </div> -->
      <div class="text-label">
              <div class="text-center">
                <h4 class="title-header">
                  {{ $t("label.label_remote_infomation") }}
                </h4>
              </div>
            </div>
      <div class="create_form">
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("employee.label_employee_name") }}
            </label>
            <CInput
              v-model="account.name"
              :disabled="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("commons.label_start_date") }}
            </label>
            <CInput
              v-model="requestInfo.start_date"
              :disabled="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("commons.label_end_date") }}
            </label>
            <CInput
              v-model="requestInfo.end_date"
              :disabled="true"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("additional_timeSheet.reason") }}
            </label>
            <CInput
              v-model="requestInfo.note"
              :disabled="true"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("commons.status") }}
            </label>
            <CInput
              :value="
                $t(
                  'commons.label_status_' +
                    requestInfo.status
                )
              "
              :disabled="true"
            />
          </CCol>
        </CRow>
        <!-- Overtime approval list-->
        <CRow class="mt-4">
          <CCol md="12" sm="12" class="employees-form approval-ot">
            <div class="text-label">
              <div class="text-center">
                <h4 class="title-header">
                  {{ $t("overtime.information_approval_ot") }}
                </h4>
              </div>
            </div>
            <div class="text-label-content">
              <div class="table-responsive table-employee-note">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="index">#</th>
                      <th class="create-by">
                        {{ $t("overtime.employee_approval") }}
                      </th>
                      <th class="create-at">
                        {{ $t("overtime.employee_approval_status") }}
                      </th>
                      <th>
                        {{ $t("overtime.employee_approval_note") }}
                      </th>
                      <th>
                        {{ $t("overtime.employee_approval_time") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in requestInfo.remote_request_approve"
                      :key="index"
                    >
                      <th scope="row index">{{ index + 1 }}</th>
                      <td>{{ item.approved_by }}</td>
                      <td>
                        {{
                          $t(
                            `overtime.employee_approval_${item.status}`
                          )
                        }}
                      </td>
                      <td class="comment">{{ item.comment }}</td>
                      <td v-if ="item.status != 1">{{ item.updated_at | formatDateTime }}</td>
                      <td v-else></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow class="mobile-row-btn">
          <CCol class="employees-form approval-ot text-center">
            <button
              class="btn btn-success"
              @click="$ref['editRequest'].open(id)"
              v-if="requestInfo.status == 1"
            >
              <CIcon
                name="cil-pencil"
                style="margin-right: 3px; border: 1px solid #fff"
              ></CIcon>
              {{ $t("button.label_action_edit") }}
            </button>
          </CCol>
        </CRow>
      </div>
    </div>
  </CContainer>
  <EditRemoteRequestModal ref="editRequest" @getData="showRemoteRequest"/>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
// import ApprovalrequestInfo from "./ApprovalAdditionalTimesheet";
import EditRemoteRequestModal from "../RemoteModal/EditRemoteRequestModal.vue";

export default {
  name: "DetailRemoteRequest",
  props: ["id"],
  components: {
    // ApprovalAdditionalTimeSheet,
    EditRemoteRequestModal,
  },
  data() {
    return {
      listEmployeeIdApproval: [],
    };
  },

  computed: {
    ...mapGetters({
      requestInfo: "remote-request/requestInfo",
      userRemoteInfo: "remote-request/userInfo",
      flagNotification: "commons/flagNotification",
      account: "auth/account",
    }),
  },

  methods: {
    ...mapActions("remote-request", ["getRemoteRequestInfo"]),
    ...mapMutations("commons", ["setNotificationFlag"]),

    async showRemoteRequest() {
      await this.getRemoteRequestInfo(this.id);
      this.setNotificationFlag(false);
    },

    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
      }
    },
  },

  async created() {
    await this.showRemoteRequest();
  },

  // watch: {
  //   async flagNotification(value) {
  //     if (value) {
  //       this.listEmployeeIdApproval = [];
  //       await this.showRemoteRequest();
  //     }
  //   }
  // }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1024px) {
  .mobile-header {
    margin-bottom: 0;
  }
  .approval-overtime {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .row-mobile {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .col-mobile {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .employees-form {
    margin-top: 30px !important;
  }
  .save-info {
    width: 100%;
  }
  .cancel-employee {
    width: 100%;
    margin-top: 5px !important;
  }
  .table {
    width: 550px;
  }
}

.modal-content {
  border: none;

  .warning-title {
    display: flex;
    justify-content: center;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #303c54;
    img {
      margin-right: 10px;
    }
  }
}

.approval-overtime {
  .col-md-10.offset-md-2 {
    margin: auto;
  }

  td.comment {
    max-width: 300px;
    word-wrap: break-word;
  }

  .save-info {
    border-radius: 10px;
    width: 210px;
    height: 40px;
    background-color: #3d4cdc;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    margin-right: 10px;
  }

  label {
    font-weight: 600;
  }

  .input-group {
    margin-bottom: 0px !important;
  }

  .cancel-employee {
    border-radius: 10px;
    width: 210px;
    height: 40px;
    font-weight: 700;
    font-size: 14px;
    background-color: #ececec;
    color: #6f6f6f;
  }

  span.require {
    color: #ff1a1a;
  }

  span.required {
    color: #ff1a1a;
    margin-top: -15px;
  }

  .submit-form {
    margin-top: 30px;
    text-align: center;
  }
}
</style>